/*
 * @Description: 
 * @Author: Lynn Qin
 * @Date: 2021-12-20 14:43:11
 * @LastEditTime: 2022-02-24 18:34:23
 */
import { httpNbb } from '@/utils/http/http-nbb'

// 获取聊天室列表
export const getChatRoomList = httpNbb.post('/teach-server/api/get-chat-group-list/v1')

// 获取融云token
export const getChatRoomToken = httpNbb.post('/teach-server/api/generate-chat-group-token/v1')

// 获取聊天室信息
export const getChatRoomInfo = httpNbb.post('/teach-server/api/get-chat-group-details/v1')

// 加入聊天室
export const joinChatRoom = httpNbb.post('/teach-server/api/join-chat-group/v1')

// 获取群聊历史消息
export const getChatRoomHistory = httpNbb.post('/teach-server/api/get-group-historical-message/v1')

// 禁言/解禁群聊
export const bannedChatRoom = httpNbb.post('/teach-server/api/banned-group-chat/v1')

// 获取群成员列表
export const getChatRoomMember = httpNbb.post('/teach-server/api/get-group-chat-members/v1')

// 获取腾讯云VOD token
export const getSign = httpNbb.get('/teach-server/api/get-sign/v1')
/**********直播*******/
// 创建或者编辑
export const createEditLive = httpNbb.post('/teach-server/api/create-edit-live/v1')
// 列表
export const getLiveList = httpNbb.post('/teach-server/api/get-live-list-page/v1')
// 上下架结束直播
export const putOnOffEndLive = httpNbb.post('/teach-server/api/put-on-off-end-live/v1')
// 获取直播详情
export const getLiveDetail = httpNbb.post('/teach-server/api/open-platform-get-live-detail/v1')

/****发布短视频 **/
// 发布
export const shortVideoInsert =  httpNbb.post('/teach-server/api/short-video-insert/v1')
// 编辑
export const shortVideoEdit =  httpNbb.post('/teach-server/api/short-video-edit/v1')
// 详情
export const shortVideoDetail =  httpNbb.postForm('/teach-server/api/short-video-detail/v1')
// 直播列表
export const getVideoList =  httpNbb.post('/teach-server/api/page-video-release-info/v1')
// 删除
export const shortVideodel =  httpNbb.postForm('/teach-server/api/short-video-del/v1')
// 下架/上架
export const shortVideoShelf =  httpNbb.post('/teach-server/api/short-video-shelf/v1')
// 获取禁言成员列表
export const getChatRoomMuteList = httpNbb.post('/teach-server/api/get-group-chat-mute-list/v1')
export const createVideoSnapshot = httpNbb.post('/teach-server/api/tencent-vod/create-video-snapshot/v1')
export const getVideoSnapshot = httpNbb.post('/teach-server/api/tencent-vod/get-video-snapshot/v1')
